import { Controller } from '@hotwired/stimulus'

const MESSAGE = 'Are you sure you want to leave this page? Your inputs will not be saved.'

export default class extends Controller<HTMLElement> {
  // The two helpers below are written as arrow functions as they are not using `this`
  // and need to be added/removed on event listeners (so they need keep their shape)
  _unloadingWindow = (event: BeforeUnloadEvent): void => {
    // here we cannot control the message: preventing default will display a generic confirmation from the browser
    event.preventDefault()
  }

  _changingTurboPage = (event: Event): void => {
    if (!confirm(MESSAGE)) {
      event.preventDefault()
    }
  }

  _attachEventsToShowConfirmation(): void {
    window.addEventListener('beforeunload', this._unloadingWindow)
    document.addEventListener('turbo:before-visit', this._changingTurboPage)

    // This is a global function that can be called to cancel the confirmation
    ;(window as any).cancelConfirmLeave = this._detachEventsToShowConfirmation.bind(this)
  }

  _detachEventsToShowConfirmation(): void {
    window.removeEventListener('beforeunload', this._unloadingWindow)
    document.removeEventListener('turbo:before-visit', this._changingTurboPage)
  }

  connect(): void {
    const form = this.element.previousElementSibling as HTMLFormElement
    form.addEventListener('change', this._attachEventsToShowConfirmation.bind(this))
    form
      .querySelector('button[type="submit"]')
      ?.addEventListener('click', this._detachEventsToShowConfirmation.bind(this))
  }

  disconnect(): void {
    this._detachEventsToShowConfirmation()
  }
}
